import {
  CircularProgress,
  TextField as MUITextField,
  Typography,
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import ColorButton from "components/common/ColorButton";
import {
  DistrictField,
  ProvinceField,
  SubDistrictField,
  useAddress,
  ZipcodeField,
} from "components/request-document/components/Address";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";
import {
  checkSmartO,
  checkSmartOSlice,
  selectCheckSmartO,
} from "redux/modules/visaForm";

const TextField = React.memo(MUITextField);

export default function PersonalInfoDependent({ formik }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const canEdit = useSelector(canEditForm);
  const addressFieldOptions = useAddress({
    formik,
    ProvinceFieldName: "document.PersonalProvince",
    DistrictFieldName: "document.PersonalDistrict",
    SubDistrictFieldName: "document.PersonalSubDistrict",
    ZipcodeFieldName: "document.PersonalZipcode",
  });

  const masterData = useSelector(selectMasterData);
  const checkSmartOState = useSelector(selectCheckSmartO);
  const nationalityConfig = get(masterData, "nationalityConfig", []);
  const titleConfig = get(masterData, "titleConfig", []);
  const accommodationConfig = get(masterData, "accommodationConfig", []);
  const handleClickCheckHolder = async () => {
    const SmartNo = formik.values.document?.SmartfromMainNo ?? "";

    await formik.setFieldTouched("document.SmartfromMainNo");
    await formik.setTouched({ "document.SmartfromMainNo": true });

    if (SmartNo) {
      dispatch(checkSmartO({ SmartNo }));
    }
  };

  useEffect(() => {
    if (!checkSmartOState.isLoading) {
      if (checkSmartOState.isSuccess) {
        dispatch(checkSmartOSlice.actions.clearAsyncState());
        console.log(checkSmartOState);

        if (!checkSmartOState.data.firstname) {
          formik.setFieldError(
            "document.SmartfromMainNo",
            "Holder or applicant not found."
          );
          // formik.setFieldValue("document.accompanyID", false);
        } else {
          // formik.setFieldValue("document.accompanyID", true);
          formik.setFieldValue(
            "document.PersonalPersonThailand",
            checkSmartOState.data.firstname +
              checkSmartOState.data.middleName +
              checkSmartOState.data.lastName
          );

          formik.setFieldValue(
            "document.PersonalMobilePhoneNumber",
            checkSmartOState.data.mobile
          );
          formik.setFieldValue(
            "document.PersonalEmailAddress",
            checkSmartOState.data.email
          );
        }
      } else if (checkSmartOState.isFailure) {
        alert(checkSmartOState.error?.message);
        dispatch(checkSmartOSlice.actions.clearAsyncState());
        // formik.setFieldValue("document.accompanyID", false);
        formik.setFieldValue("document.SmartfromMainNo", "");
      }
    }
  }, [checkSmartOState, dispatch]);
  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <Typography>Full English name as in passport</Typography>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={1}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Title</InputLabel>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                // style={{ width: 200 }}
                error={isError("personal.title", formik)}
              >
                <InputLabel>Select Title</InputLabel>
                <Select
                  label="Selected Title"
                  name="personal.titleID"
                  value={formik.values.personal.titleID}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={!canEdit}
                >
                  {titleConfig.map((title) => (
                    <MenuItem value={title.titleID} key={title.titleID}>
                      {title.titleEN}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText error={isError("personal.titleID", formik)}>
                  {getErrorMessage("personal.titleID", formik)}
                </FormHelperText>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>First name</InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="personal.fistName"
                value={formik.values.personal.fistName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("personal.fistName", formik)}
                helperText={getErrorMessage("personal.fistName", formik)}
                disabled={!canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Middle name</InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="personal.middleName"
                value={formik.values.personal.middleName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("personal.middleName", formik)}
                helperText={getErrorMessage("personal.middleName", formik)}
                disabled={!canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Last name</InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="personal.lastName"
                value={formik.values.personal.lastName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("personal.lastName", formik)}
                helperText={getErrorMessage("personal.lastName", formik)}
                disabled={!canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>
                Current Nationality / Nationality at birth, if different
              </InputLabel>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                // style={{ width: 200 }}
                error={isError("personal.nationalityID", formik)}
              >
                <InputLabel>Select your nationality</InputLabel>
                <Select
                  label="Selected your nationality"
                  name="personal.nationalityID"
                  value={formik.values.personal.nationalityID}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={!canEdit}
                >
                  {nationalityConfig.map((nationality) => (
                    <MenuItem
                      value={nationality.nationalityID}
                      key={nationality.nationalityID}
                    >
                      {nationality.nationalityName}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText
                  error={isError("personal.nationalityID", formik)}
                >
                  {getErrorMessage("personal.nationalityID", formik)}
                </FormHelperText>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Date of birth (dd-mm-yyyy)</InputLabel>
              <DatePicker
                // style={{ width: 200 }}
                className={classes.formControl}
                inputVariant="outlined"
                disableFuture={false}
                openTo="year"
                format="DD-MM-YYYY"
                label="Date of birth"
                views={["year", "month", "date"]}
                name={`personal.birthDate`}
                value={get(formik.values, `personal.birthDate`, null) || null}
                onChange={(date) => {
                  formik.setFieldValue(
                    `personal.birthDate`,
                    date.format("YYYY-MM-DD")
                  );
                }}
                error={isError(`personal.birthDate`, formik)}
                helperText={getErrorMessage(`personal.birthDate`, formik)}
                disabled={!canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel style={{ wordBreak: "break-all" }}>
                Place of birth (city, province/state, country)
              </InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="personal.placeOfBirth"
                value={formik.values.personal.placeOfBirth}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("personal.placeOfBirth", formik)}
                helperText={getErrorMessage("personal.placeOfBirth", formik)}
                disabled={!canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Gender</InputLabel>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="personal.gender"
                      value="M"
                      checked={formik.values.personal.gender === "M"}
                      onClick={() => {
                        formik.setFieldValue("personal.gender", "M");
                      }}
                    />
                  }
                  label="Male"
                />
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="personal.gender"
                      value="F"
                      checked={formik.values.personal.gender === "F"}
                      onClick={() => {
                        formik.setFieldValue("personal.gender", "F");
                      }}
                    />
                  }
                  label="Female"
                />
              </FormGroup>
              <FormHelperText error={isError("personal.gender", formik)}>
                {getErrorMessage("personal.gender", formik)}
              </FormHelperText>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Marital status</InputLabel>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="Single"
                      value="S"
                      checked={formik.values.document.Marittal === "S"}
                      onClick={() => {
                        formik.setFieldValue("document.Marittal", "S");
                        formik.setFieldValue("personal.MaritalID", "S");
                      }}
                    />
                  }
                  label="Single"
                />
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="Married"
                      value="M"
                      checked={formik.values.document.Marittal === "M"}
                      onClick={() => {
                        formik.setFieldValue("document.Marittal", "M");
                        formik.setFieldValue("personal.MaritalID", "M");
                      }}
                    />
                  }
                  label="Married"
                />
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="Divorced"
                      value="D"
                      checked={formik.values.document.Marittal === "D"}
                      onClick={() => {
                        formik.setFieldValue("document.Marittal", "D");
                        formik.setFieldValue("personal.MaritalID", "D");
                      }}
                    />
                  }
                  label="Divorced"
                />
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="Window"
                      value="W"
                      checked={formik.values.document.Marittal === "W"}
                      onClick={() => {
                        formik.setFieldValue("document.Marittal", "W");
                        formik.setFieldValue("personal.MaritalID", "W");
                      }}
                    />
                  }
                  label="Widowed"
                />
              </FormGroup>
              <FormHelperText error={isError("document.Marittal", formik)}>
                {getErrorMessage("document.Marittal", formik)}
              </FormHelperText>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Passport number</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="personal.passportNumber"
                value={formik.values.personal.passportNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("personal.passportNumber", formik)}
                helperText={getErrorMessage("personal.passportNumber", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Issued at</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="personal.issuedAt"
                value={formik.values.personal.issuedAt}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("personal.issuedAt", formik)}
                helperText={getErrorMessage("personal.issuedAt", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={1}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Date of issue (dd-mm-yyyy)</InputLabel>
              <DatePicker
                disabled={!canEdit}
                // style={{ width: 200 }}
                className={classes.formControl}
                inputVariant="outlined"
                disableFuture={false}
                openTo="year"
                format="DD-MM-YYYY"
                label="Date of issue"
                views={["year", "month", "date"]}
                name={`document.DateIssuedat`}
                value={
                  get(formik.values, `document.DateIssuedat`, null) || null
                }
                onChange={(date) => {
                  formik.setFieldValue(
                    `document.DateIssuedat`,
                    date.format("YYYY-MM-DD")
                  );
                  formik.setFieldValue(
                    "personal.dateofIssue",
                    date.format("YYYY-MM-DD")
                  );
                }}
                error={isError(`document.DateIssuedat`, formik)}
                helperText={getErrorMessage(`document.DateIssuedat`, formik)}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Valid until ( dd-mm-yyyy )</InputLabel>
              <DatePicker
                disabled={!canEdit}
                className={classes.formControl}
                // style={{ width: 200 }}
                inputVariant="outlined"
                disableFuture={false}
                openTo="year"
                format="DD-MM-YYYY"
                label="Valid until"
                views={["year", "month", "date"]}
                name={`document.ValiduntilIssuedat`}
                value={
                  get(formik.values, `document.ValiduntilIssuedat`, null) ||
                  null
                }
                onChange={(date) => {
                  formik.setFieldValue(
                    `document.ValiduntilIssuedat`,
                    date.format("YYYY-MM-DD")
                  );
                  formik.setFieldValue(
                    "personal.validuntil",
                    date.format("YYYY-MM-DD")
                  );
                }}
                error={isError(`document.ValiduntilIssuedat`, formik)}
                helperText={getErrorMessage(
                  `personal.ValiduntilIssuedat`,
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Address in home country</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.PersonalAddressInHome"
                value={formik.values.document.PersonalAddressInHome}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.PersonalAddressInHome", formik)}
                helperText={getErrorMessage(
                  "document.PersonalAddressInHome",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>
                Current address in Thailand (if applicable)
              </InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="document.PersonalAddressInThai"
                value={formik.values.document.PersonalAddressInThai}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.PersonalAddressInThai", formik)}
                helperText={getErrorMessage(
                  "document.PersonalAddressInThai",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={1}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Residence Type</InputLabel>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                // style={{ width: 200 }}
                error={isError("document.PersonalResidenceType", formik)}
              >
                <InputLabel>Residence Type</InputLabel>
                <Select
                  label="Residence  Type"
                  name="document.PersonalResidenceType"
                  value={formik.values.document.PersonalResidenceType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={!canEdit}
                >
                  {accommodationConfig.map((title) => (
                    <MenuItem
                      value={title.accommodationID}
                      key={title.accommodationID}
                    >
                      {title.accommodationName}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText
                  error={isError("document.PersonalResidenceType", formik)}
                >
                  {getErrorMessage("document.PersonalResidenceType", formik)}
                </FormHelperText>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Soi</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="personal.soi"
                inputProps={{ maxLength: 10 }}
                value={formik.values.personal.soi}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("personal.soi", formik)}
                helperText={getErrorMessage("personal.soi", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Road</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="personal.road"
                value={formik.values.personal.road}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("personal.road", formik)}
                helperText={getErrorMessage("personal.road", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={2}>
          <ProvinceField {...addressFieldOptions} />
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <DistrictField {...addressFieldOptions} />
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <SubDistrictField {...addressFieldOptions} />
        </StyledTableCell>
        <StyledTableCell colSpan={1}>
          <ZipcodeField {...addressFieldOptions} />
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Home / mobile phone number</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.PersonalPhoneNumber"
                onKeyDown={(e) => {
                  const pattern = /[^0-9^+]/g;
                  const isNotAllow = e.key.length === 1 && pattern.test(e.key);

                  if (isNotAllow) {
                    e.preventDefault();
                  }
                }}
                value={formik.values.document.PersonalPhoneNumber}
                onChange={(e) => {
                  formik.setFieldValue(
                    `document.PersonalPhoneNumber`,
                    e.target.value
                  );
                  formik.setFieldValue(`personal.mobile`, e.target.value);
                }}
                onBlur={formik.handleBlur}
                error={isError("document.PersonalPhoneNumber", formik)}
                helperText={getErrorMessage(
                  "document.PersonalPhoneNumber",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>E-mail address</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.PersonalEmail"
                value={formik.values.document.PersonalEmail}
                onChange={(e) => {
                  formik.setFieldValue(
                    `document.PersonalEmail`,
                    e.target.value
                  );
                  formik.setFieldValue(`personal.email`, e.target.value);
                }}
                onBlur={formik.handleBlur}
                error={isError("document.PersonalEmail", formik)}
                helperText={getErrorMessage("document.PersonalEmail", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <InputLabel>
            Document number of the main LTR Visa applicant.
          </InputLabel>

          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <div style={{ display: "flex" }}>
                <TextField
                  disabled={!canEdit}
                  variant="outlined"
                  className={classes.textField}
                  name="document.SmartfromMainNo"
                  value={formik.values.document.SmartfromMainNo}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("document.SmartfromMainNo", formik)}
                  helperText={getErrorMessage(
                    "document.SmartfromMainNo",
                    formik
                  )}
                />
                <ColorButton
                  disabled={!canEdit}
                  style={{ height: 40, marginLeft: 20, marginTop: 10 }}
                  variant="contained"
                  color={"error"}
                  onClick={() => {
                    if (!checkSmartOState.isLoading) {
                      handleClickCheckHolder();
                    }
                  }}
                >
                  {checkSmartOState.isLoading ? (
                    <>
                      <CircularProgress
                        size={16}
                        style={{ marginRight: 8, color: "inherit" }}
                      />{" "}
                      Checking...
                    </>
                  ) : formik.values.document.accompanyID ? (
                    "Found the holder or applicant"
                  ) : (
                    "Check holder or applicant"
                  )}
                </ColorButton>
              </div>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>
                Relationship with the main LTR holder/applicant.{" "}
              </InputLabel>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="document.RelationshipLTRholderID"
                      checked={
                        formik.values.document.RelationshipLTRholderID === "S"
                      }
                      onClick={() => {
                        formik.setFieldValue(
                          "document.RelationshipLTRholderID",
                          formik.values.document.RelationshipLTRholderID === "S"
                            ? ""
                            : "S"
                        );
                        formik.setFieldValue(
                          "document.PersonalRelationshipApplicant",
                          "Spouse"
                        );
                      }}
                    />
                  }
                  label="spouse "
                />
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="document.RelationshipLTRholderID"
                      checked={
                        formik.values.document.RelationshipLTRholderID === "C"
                      }
                      onClick={() => {
                        formik.setFieldValue(
                          "document.RelationshipLTRholderID",
                          formik.values.document.RelationshipLTRholderID === "C"
                            ? ""
                            : "C"
                        );
                        formik.setFieldValue(
                          "document.PersonalRelationshipApplicant",
                          "Parent"
                        );
                      }}
                    />
                  }
                  label="child"
                />
              </FormGroup>
              <FormHelperText
                error={isError("document.RelationshipLTRholderID", formik)}
              >
                {getErrorMessage("document.RelationshipLTRholderID", formik)}
              </FormHelperText>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Name of contact person in Thailand</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.PersonalPersonThailand"
                value={formik.values.document.PersonalPersonThailand}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                inputProps={{ readOnly: true }}
                error={isError("document.PersonalPersonThailand", formik)}
                helperText={getErrorMessage(
                  "document.PersonalPersonThailand",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Relationship with the applicant</InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="document.PersonalRelationshipApplicant"
                value={formik.values.document.PersonalRelationshipApplicant}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                inputProps={{ readOnly: true }}
                error={isError(
                  "document.PersonalRelationshipApplicant",
                  formik
                )}
                helperText={getErrorMessage(
                  "document.PersonalRelationshipApplicant",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>E-mail address</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.PersonalEmailAddress"
                value={formik.values.document.PersonalEmailAddress}
                onChange={formik.handleChange}
                inputProps={{ readOnly: true }}
                onBlur={formik.handleBlur}
                error={isError("document.PersonalEmailAddress", formik)}
                helperText={getErrorMessage(
                  "document.PersonalEmailAddress",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Mobile phone number</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.PersonalMobilePhoneNumber"
                value={formik.values.document.PersonalMobilePhoneNumber}
                onChange={formik.handleChange}
                inputProps={{ readOnly: true }}
                onKeyDown={(e) => {
                  const pattern = /[^0-9^+]/g;
                  const isNotAllow = e.key.length === 1 && pattern.test(e.key);

                  if (isNotAllow) {
                    e.preventDefault();
                  }
                }}
                onBlur={formik.handleBlur}
                error={isError("document.PersonalMobilePhoneNumber", formik)}
                helperText={getErrorMessage(
                  "document.PersonalMobilePhoneNumber",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
